import { render, staticRenderFns } from "./2.vue?vue&type=template&id=36f8611a&scoped=true"
import script from "./2.vue?vue&type=script&lang=js"
export * from "./2.vue?vue&type=script&lang=js"
import style0 from "./2.vue?vue&type=style&index=0&id=36f8611a&prod&lang=less&scoped=true"
import style1 from "./2.vue?vue&type=style&index=1&id=36f8611a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8611a",
  null
  
)

export default component.exports